<template>
  <div class="block page10 f-r f-c">
    <PageHeader
      :title="moduleData['3_9_2_1']"
      :sub-title="moduleData['3_9_2_1_en']"
      :page-logo="reportCustomization.pageLogo"
    />
    <PageTips :page-num="pageNum"/>
    <div class="page10-body f-r j-b">
      <div class="page10-body-left">
        <TableNav width="551px" height="67px">
          <template v-slot:title>
            <div class="page10-nav f-c j-c">
              <div class="title1">{{ PAGE_TEXT[commonLang].residentialAvgPrice }}</div>
              <div class="desc f-r j-b a-c">
                <div class="desc1">{{ PAGE_TEXT[commonLang].avgHousePrice }} {{avg1.p ? `（${avg1.p} ${PAGE_TEXT[commonLang].yuan}/㎡）` : `（${PAGE_TEXT[commonLang].noData}）`}}</div>
                <div class="desc1">{{ PAGE_TEXT[commonLang].avgDistance }} {{avg1.d ? `（${avg1.d} ${PAGE_TEXT[commonLang].meter}）` : `（${PAGE_TEXT[commonLang].noData}）`}}</div>
              </div>
            </div>
          </template>
        </TableNav>
        <PointChart :unit="PAGE_TEXT[commonLang].yuan" :chart-data="chart1" style="height: 303px; margin-bottom: 20px">
          <Empty :text="PAGE_TEXT[commonLang].noResidentialCoverage" v-if="!chart1 || !chart1.length"/>
          <Empty :text="PAGE_TEXT[commonLang].noDataObtained" v-else-if="!chart1.filter(c => !!c[1]).length"/>
        </PointChart>
        <TableNav width="551px" height="67px">
          <template v-slot:title>
            <div class="page10-nav f-c j-c">
              <div class="title1">{{ PAGE_TEXT[commonLang].residentialHouseholds }}</div>
              <div class="desc f-r j-b a-c">
                <div class="desc1">{{ PAGE_TEXT[commonLang].avgPlannedHouseholds }} {{avg2.p ? `（${avg2.p} ${PAGE_TEXT[commonLang].households}）` : `（${PAGE_TEXT[commonLang].noData}）`}}</div>
                <div class="desc1">{{ PAGE_TEXT[commonLang].avgDistance }} {{avg2.d ? `（${avg2.d} ${PAGE_TEXT[commonLang].meter}）` : `（${PAGE_TEXT[commonLang].noData}）`}}</div>
              </div>
            </div>
          </template>
        </TableNav>
        <PointChart :unit="PAGE_TEXT[commonLang].households" :chart-data="chart2" style="height: 303px">
          <Empty :text="PAGE_TEXT[commonLang].noResidentialCoverage"  v-if="!chart2 || !chart2.length"/>
          <Empty :text="PAGE_TEXT[commonLang].noDataObtained" v-else-if="!chart2.filter(c => !!c[1]).length"/>
        </PointChart>
      </div>
      <div class="page10-body-right f-c j-b">
        <div class="page4-map" id="page4Map">
          <Empty :text="PAGE_TEXT[commonLang].noResidentialCoverage" v-if="!catData?.poi || !catData.poi.length"/>
        </div>
        <div v-if="reportCustomization.showDataSource" class="page4-map-tips">
          {{ PAGE_TEXT[commonLang].dataSource }}
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import PageHeader from "./components/PageHeader";
import TableNav from "./components/TableNav";
import PageTips from "./components/PageTips";
import Empty from "./components/Empty";

import AMapLoader from "@amap/amap-jsapi-loader";
import { AMAP_KEY } from "@/constants/common";
import { shallowRef } from "@vue/reactivity";

import { computed, onMounted } from "vue";
import PointChart from "./components/PointChart";
import { mapAddCircle, addMapCenter, mapAddPolygonV2 } from "@/utils/pdf";
import { useStore } from "vuex";

import { getMapDelayByMarkerCount } from '@/utils'
import {
  drawMapKeepAlive,
} from '@/api/apiv2'

const props = defineProps({
    pageNum: String,
    cityInfo: {
      type: Object,
      default: () => {
        return {};
      },
    },
    catData: {
      type: Object,
      default: () => {
        return {
          count: 0,
          poi: []
        };
      },
    },
    moduleData: {
      type: Object,
      default: () => {
        return {
          "3_9_2_1":"",
          "3_9_2_1_en":"",
        };
      },
    },
    reportCustomization: {
      type: Object,
      default: () => {},
    },
    commonLang: {
      type: String,
      default: 'zh'
    }
  });

const PAGE_TEXT = {
  'zh': {
    residentialAvgPrice: '住宅小区均价分布',
    avgHousePrice: '平均房价',
    avgDistance: '平均距离',
    noData: '暂无数据',
    yuan: '元',
    meter: 'm',
    residentialHouseholds: '住宅小区规划户数分布',
    avgPlannedHouseholds: '平均规划户数',
    households: '户',
    noResidentialCoverage: '当前区域暂无住宅覆盖',
    noDataObtained: '当前区域暂未获取到数据',
    dataSource: '数据来源：边界房产大数据，房产平台数据整合'
  },
  'en': {
    residentialAvgPrice: 'Residential Average Price Distribution',
    avgHousePrice: 'Average House Price',
    avgDistance: 'Average Distance',
    noData: 'No Data',
    yuan: 'CNY',
    meter: 'm',
    residentialHouseholds: 'Residential Planned Households Distribution',
    avgPlannedHouseholds: 'Average Planned Households',
    households: 'households',
    noResidentialCoverage: 'No residential coverage in current area',
    noDataObtained: 'No data obtained in current area',
    dataSource: 'Data Source: Boundary real estate big data, real estate platform data integration'
  }
};

    let map = shallowRef(null);
    const addMaker = (amap, map, newData) => {
      let markerList = [];
      newData.forEach((v) => {
        let marker = new amap.Marker({
          position: new amap.LngLat(
            v.location.split(",")[0],
            v.location.split(",")[1]
          ),
          content: `
                <div style="width: 12px;height: 12px; border-radius: 50%;background: #1644FF;"></div>
              `,
        });
        markerList.push(marker);
      });
      map.add(markerList);
    };
    const chart1 = computed(() => {
      return props.catData.poi.filter((el) => !!(el.housePrice_202401*1)).map((el) => {
        return [el.distance * 1 || 0, el.housePrice_202401 * 1 || 0];
      });
    });
    const avg1 = computed(() => {
      if (chart1.value.length === 0)
        return {
          d: 0,
          p: 0,
        };
      return {
        d: (
          chart1.value.map((el) => el[0]).filter(el => el).reduce((pre, next) => {
            return pre + next
          },0) /
          (chart1.value.map((el) => el[0]).filter(el => el)?.length || 1)
        ).toFixed(2),
        p: (
          chart1.value.map((el) => el[1]).filter(el => el).reduce((pre, next) => {
            return pre + next
          },0) /
          (chart1.value.map((el) => el[1]).filter(el => el)?.length || 1)
        ).toFixed(2),
      };
    });
    const chart2 = computed(() => {
      return props.catData.poi.filter((el) => !!(el.households*1)).map((el) => {
        return [el.distance * 1 || 0, el.households * 1 || 0];
      });
    });
    const avg2 = computed(() => {
      if (chart2.value.length === 0)
        return {
          d: 0,
          p: 0,
        };
      return {
        d: (
          chart2.value.map((el) => el[0]).filter(el => el).reduce((pre, next) => {
            return pre + next
          },0) /
          (chart2.value.map((el) => el[0]).filter(el => el)?.length || 1)
        ).toFixed(2),
        p: (
          chart2.value.map((el) => el[1]).filter(el => el).reduce((pre, next) => {
            return pre + next
          },0) /
          (chart2.value.map((el) => el[1]).filter(el => el)?.length || 1)
        ).toFixed(0),
      };
    });
    onMounted(() => {
      const store = useStore()
      AMapLoader.load({
        key: AMAP_KEY, // 申请好的Web端开发者Key，首次调用 load 时必填
        version: "2.0", // 指定要加载的 JSAPI 的版本，缺省时默认为 1.4.15
        plugins: [""], // 需要使用的的插件列表，如比例尺'AMap.Scale'等
      })
        .then((AMap) => {
          map = new AMap.Map("page4Map", {
            WebGLParams: {
                preserveDrawingBuffer:true
            },
            dragEnable: false,
            zoomEnable: false,
            zoom: store.getters.mapZoom, //初始化地图级别
            center: props.cityInfo.location.split(","), //初始化地图中心点位置
          });
          addMaker(AMap, map, props.catData.poi)

          if (props.cityInfo.is_polygon) {
            mapAddPolygonV2(props.cityInfo?.polygon || '', map)
          } else {
            mapAddCircle(props.cityInfo, map);
          }
          addMapCenter(AMap, map, props.cityInfo.location)

          // 等待地图渲染
          const delay = getMapDelayByMarkerCount(props?.catData?.poi?.length || 0)
          drawMapKeepAlive(delay).catch((e) => {})

          map.setFitView()
        })
        .catch((e) => {
          console.log(e);
        });
    });
</script>

<style lang="less">
.page10 {
  position: relative;
  background: #ffffff;
  padding: 26px 60px 32px 0;

  .page10-body {
    flex-grow: 1;
    padding: 67px 20px 0 37px;
    .page10-body-left {
      width: 551px;
      .page10-nav {
        height: 100%;
        .title1 {
          font-size: 24px;

          font-weight: bold;
          color: #ffffff;
          line-height: 33px;
        }
        .desc {
          height: 20px;
          font-size: 14px;

          font-weight: bold;
          color: #ffffff;
          line-height: 20px;
        }
      }
    }
    .page10-body-right {
      width: 1192px;
      .page4-map {
        width: 100%;
        height: 760px;
      }
      .page4-map-tips {
        flex-shrink: 0;
        text-align: right;
        height: 28px;
        font-size: 20px;
        font-weight: 400;
        color: #9a9a9a;
        line-height: 28px;
      }
    }
  }
}
</style>
